import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const authentication = localStorage.getItem("authorization");
  console.log(authentication);
  if (!authentication) {
    return <Navigate to="/" />;
  }
  return children;
};

export default PrivateRoute;
